/* eslint-disable no-alert, no-console */ /* eslint-disable no-duplicate-imports */
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '../../client'
import type { RequestConfig, ResponseErrorConfig } from '../../client'
import type { PutApiUsersByIdMutationRequest, PutApiUsersByIdMutationResponse, PutApiUsersByIdPathParams } from '../models/PutApiUsersById'

function getPutApiUsersByIdUrl(id: PutApiUsersByIdPathParams['id']) {
  return `/api/users/${id}.json` as const
}

/**
 * @description Danish: Opdater bruger
 * @summary Update User
 * {@link /api/users/:id.json}
 */
export async function putApiUsersById(
  id: PutApiUsersByIdPathParams['id'],
  data?: PutApiUsersByIdMutationRequest,
  config: Partial<RequestConfig<PutApiUsersByIdMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<PutApiUsersByIdMutationResponse, ResponseErrorConfig<Error>, PutApiUsersByIdMutationRequest>({
    method: 'PUT',
    url: getPutApiUsersByIdUrl(id).toString(),
    data,
    ...requestConfig,
  })
  return res.data
}